import React from "react";

export const ContactAreaMap = () => {
  return (
    <div className="contact-map">
      <iframe
        src="https://maps.google.com/maps?q=Mahmood%20Plaza%20Blue%20Area%20Islamabad&t=&z=15&ie=UTF8&iwloc=&output=embed"
        allowFullScreen
        loading="lazy"
        title="contact map"
      ></iframe>
    </div>
  );
};
